function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDownloadPopupMac = function SvgDownloadPopupMac(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 236 125",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAEEF1"
    },
    d: "M6,0h224c3.314,0,6,2.686,6,6v113c0,3.314-2.686,6-6,6H6c-3.314,0-6-2.686-6-6V6C0,2.686,2.686,0,6,0 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A8BCCE"
    },
    d: "M0,6c0-3.314,2.686-6,6-6h224c3.314,0,6,2.686,6,6v10H0V6z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F37171"
    },
    cx: 11.5,
    cy: 8.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D8DDE1"
    },
    cx: 23.5,
    cy: 8.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#6F9FF4"
    },
    cx: 27.5,
    cy: 68.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A8BCCE"
    },
    cx: 27.5,
    cy: 81.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D8DDE1"
    },
    cx: 35.5,
    cy: 8.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6F9FF4"
    },
    d: "M180,91h32c1.105,0,2,0.895,2,2v17c0,1.105-0.895,2-2,2h-32c-1.105,0-2-0.895-2-2V93 C178,91.895,178.895,91,180,91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBC8D1"
    },
    d: "M142,91h28c1.105,0,2,0.895,2,2v17c0,1.105-0.895,2-2,2h-28c-1.105,0-2-0.895-2-2V93 C140,91.895,140.895,91,142,91z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 33,
    style: {
      fill: "#D0D8DF"
    },
    width: 191,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 49,
    style: {
      fill: "#D0D8DF"
    },
    width: 191,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 65,
    style: {
      fill: "#D0D8DF"
    },
    width: 52,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 63,
    style: {
      fill: "#DBE3EA"
    },
    width: 72,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 63,
    style: {
      fill: "#D0D8DF"
    },
    width: 9,
    height: 11
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 79,
    style: {
      fill: "#D0D8DF"
    },
    width: 52,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M200.918,97.282l-7.193,7.193l-2.643-2.643c-0.128-0.128-0.336-0.128-0.464,0l-0.773,0.774 c-0.128,0.128-0.128,0.335,0,0.464l3.648,3.648c0.128,0.128,0.336,0.128,0.464,0l8.198-8.198c0.128-0.128,0.128-0.336,0-0.464 l-0.773-0.774C201.254,97.154,201.046,97.154,200.918,97.282L200.918,97.282z"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownloadPopupMac, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/downloadPopupMac.24b9ed64.svg";
export { ForwardRef as ReactComponent };